import { Injectable, PLATFORM_ID, inject, DOCUMENT } from '@angular/core';
import { StateService } from './storage/state.service';
import { isPlatformBrowser } from '@angular/common';
declare var FreshworksWidget;

@Injectable({ providedIn: 'root' })
export class DynamicScript {
  private stateService = inject(StateService);
  private document = inject<Document>(DOCUMENT);

  private isBrowser: boolean;
  freshWorkScriptLoaded: boolean = false;
  platformId = inject(PLATFORM_ID);
  constructor() {

    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  loadGoogleAuth(): Promise<void> {
    return this.loadExternalScript(
      'https://apis.google.com/js/platform.js',
      { showLoading: true }
    );
  }

  loadGoogleOneTap(): Promise<void> {
    return this.loadExternalScript(
      'https://accounts.google.com/gsi/client',
      { showLoading: true }
    );
  }

  loadAppleScript(): Promise<void> {
    return this.loadExternalScript(
      'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
      { showLoading: true, scriptType: 'text/javascript' }
    );
  }

  loadFreshwork(): Promise<void> {
    if (!this.isBrowser) {
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
        const scriptContainer = window.document.createElement('div');
        const widget = window.document.createElement('script');
        widget.innerHTML = `
          window.fwSettings = {
            widget_id: 201000001383,
          };
          !(function () {
            if ('function' !== typeof window.FreshworksWidget) {
              var n = function () {
                n.q.push(arguments);
              };
              (n.q = []), (window.FreshworksWidget = n);
            }
          })();
        `;
        widget.type = 'text/javascript';
        widget.async;
        widget.defer;
        scriptContainer.appendChild(widget);

        const script = window.document.createElement('script');
        script.src =
          'https://euc-widget.freshworks.com/widgets/201000001383.js';
        script.type = 'text/javascript';
        script.async;
        script.defer;
        scriptContainer.appendChild(script);

        script.onload = () => {
          resolve();
        };
        script.onerror = () => {
          reject(
            new Error(
              'Failed to load Freshworks widget: https://euc-widget.freshworks.com/widgets/201000001383.js'
            )
          );
        };

        window.document.body.appendChild(scriptContainer);
        this.freshWorkScriptLoaded = true;
      });
  }

  private loadExternalScript(
    src: string,
    options: { showLoading?: boolean; scriptType?: string } = {}
  ): Promise<void> {
    if (!this.isBrowser) {
      return Promise.resolve();
    }

    // if (options.showLoading) {
    //   this.stateService.startLoading();
    // }

    return new Promise((resolve, reject) => {
      const scriptElement = this.document.createElement('script');
      scriptElement.src = src;
      if (options.scriptType) {
        scriptElement.type = options.scriptType;
      }
      scriptElement.async = true;
      scriptElement.defer = true;
      scriptElement.onload = () => {
        if (options.showLoading) {
          this.stateService.endLoading();
        }
        resolve();
      };
      scriptElement.onerror = () => {
        // if (options.showLoading) {
        //   this.stateService.endLoading();
        // }
        reject(new Error(`Failed to load script: ${src}`));
      };
      this.document.body.appendChild(scriptElement);
    });
  }

  showFreshWorksWidget() {
    if (
      this.isBrowser &&
      this.freshWorkScriptLoaded &&
      (window as any).FreshworksWidget
    ) {
      (window as any).FreshworksWidget('show');
      this.freshWorkScriptLoaded = true;
    }
  }

  removeFreshWorkScript() {
    if (
      this.isBrowser &&
      this.freshWorkScriptLoaded &&
      (window as any).FreshworksWidget
    ) {
      (window as any).FreshworksWidget('hide', 'launcher');
      this.freshWorkScriptLoaded = false;
    }
  }
}
